import React from 'react';
import LinkPlus from "../Link/LinkPlus";
import lang from "../lang";
import {forceLogout, getAccessToken} from "../../utils/authority";
import MenuItems from "../Sidebar/MenuItems";
import {checkPermission} from "../../utils/common";
import Cookies from "js-cookie";

class SidebarMobile extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            selected: null,
            isAuth: false,
        }
    }

    UNSAFE_componentWillMount() {
        let token = getAccessToken();
        this.setState({isAuth: !!token});
        let listPermission = JSON.parse(localStorage.getItem("sas_school_per"));
        if (listPermission != null && listPermission != undefined){
            let allMenuItems = MenuItems.AdminSchool
            for (let i=0; i< allMenuItems.length; i++){
                let item = allMenuItems[i]
                let permissionArr = item.permission.split("|")
                let isShow = false;
                for (let i1=0; i1< permissionArr.length; i1++){
                    isShow = listPermission.includes(permissionArr[i1])
                    if (isShow){
                        break
                    }
                }
                item.isShow = isShow
                let children = item.children
                for (let y=0; y< children?.length; y++){
                    let permissionArr = children[y].permission.split("|")
                    let isShow = false;
                    for (let y1=0; y1< permissionArr.length; y1++){
                        isShow = listPermission.includes(permissionArr[y1])
                        if (isShow){
                            break
                        }

                    }
                    children[y].isShow = isShow
                }
            }
            this.setState({items: allMenuItems})
        }
    }

    handleClick = event => {
        event.preventDefault();
        if (this.props.onOpenModalLogin) {
            this.props.onOpenModalLogin(event);
            this.props.toggleSidebarMobile();
        }
    };

    handleShowSignup = event => {
        event.preventDefault();
        if (this.props.onOpenModalSignup) {
            this.props.onOpenModalSignup(event);
            this.props.toggleSidebarMobile();
        }
    };

    render() {
        let show = this.props.show;
        let activeClass = this.props?.activeClass;
        let parentClass = this.props?.parentClass;
        let selected = this.state.selected;
        let listCategory = JSON.parse(localStorage.getItem("sas_school_news_cat"));
        return (
            <div className={show ? "show sidebar-mobile-wrapper" : "sidebar-mobile-wrapper"}>
                <div className="p-2 sb-mb-header">
                    <span className="navbar-brand">
                        <LinkPlus to="/" className="d-flex align-items-center">
                            <img src="../../assets/images/logo.png" alt="" style={{width: 180}}/>
                        </LinkPlus>
                    </span>
                    <button type="button" className="btn btn-lg close" onClick={this.props.toggleSidebarMobile} style={{width: 30}}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="nav-link sb-mb-user">
                    <div >
                        <img
                            src={"/images/logo_sas.png"}
                            alt="avatar"
                            className="d-inline-block thumb" style={{borderRadius: "50%"}}/>
                        <span style={{fontWeight: 'bold', color: "#000"}}>{localStorage.getItem("username") ? localStorage.getItem("username") : lang.menu.guest}</span>
                    </div>

                </div>
                <div className="sb-mb-homepage-menu">
                    <div className="row">
                        <div className="col-6 pl-0">
                            <span className="nav-item dropdown sb-mb-homepage-menu-item">
                                <LinkPlus className="nav-link dropdown-toggle" to="/ad-sas-school" role="button" onClick={this.props.toggleSidebarMobile}
                                          aria-haspopup="true" aria-expanded="false">Trang chủ</LinkPlus>
                            </span>
                        </div>
                    </div>
                </div>
                {this.state.isAuth &&
                <div className="sb-mb-list">
                    <ul className="menu-y text-sm nav nav-tabs sidebar sidebar-mobile overflow-hidden">
                        {this.state.items?.map((item, index) => (
                            item.isShow &&
                                <li style={{backgroundColor: "#fff"}}>
                                    <LinkPlus to={item.url ? item.url : "#"} data-toggle="collapse"
                                              data-target={`#${item.activeClass}`}
                                              onClick={() => {
                                              // $(`#${item.activeClass}`).collapse({
                                              //     toggle: false
                                              // })
                                              if (selected == item.activeClass) {
                                                  // selected = null;
                                                  this.setState({selected: null})
                                              } else {
                                                  // selected = item.activeClass
                                                  this.setState({selected: item.activeClass})

                                              }
                                              if (!item.children) {
                                                  this.props.toggleSidebarMobile();
                                              }
                                          }}
                                              className={`${activeClass === item.activeClass ? 'active' : ''} d-block py-2 no-border-top d-flex justify-content-between align-items-center`}>
                                <span style={{minHeight: 34, lineHeight: '34px'}}>
                                    <i className={item.icon} aria-hidden="true"/>
                                    {item.title}
                                </span>
                                        {item?.children?.length > 0 &&
                                        <i className={`${(item.activeClass === parentClass || item.activeClass == selected) ? 'fas fa-angle-down' : 'fas fa-angle-right'} icon-arrow-side-bar`}/>}
                                    </LinkPlus>
                                    {item?.children?.length > 0 && <ul id={item.activeClass}
                                                                       className={`${(item.activeClass === parentClass || item.activeClass == selected) ? 'content-side-bar-active' : 'content-side-bar'} submenu-y collapse`}>
                                        {item?.children?.length > 0 && item?.children?.map((_item, idx) => (
                                            _item.isShow &&
                                                <li style={{backgroundColor: "#fff"}}>
                                                    <LinkPlus to={_item.url}
                                                              onClick={() => {
                                                              this.setState({selected: _item.parentClass})
                                                              this.props.toggleSidebarMobile()
                                                          }}
                                                              className={`${activeClass === _item.activeClass ? 'active' : ''} d-block py-2`}>
                                            <span>
                                                <i className="caret"/>
                                                {_item.title}
                                            </span>

                                                    </LinkPlus>
                                                </li>
                                            ))}
                                    </ul>}
                                </li>
                            ))}
                    </ul>
                </div>
                }
                {this.state.isAuth ?
                    <div className="sb-mb-logout d-flex justify-content-center align-items-center">
                        <button type="button" className="btn btn-sm btn-warning" onClick={forceLogout}
                                style={{minWidth: "50%", maxWidth: "50%"}}>
                            Đăng xuất
                        </button>
                    </div> :
                    <ul className="d-flex p-2 justify-content-center">
                        <li className="nav-item">
                            <button className='btn sign-up-btn bg-green color-white hide-on-tablet'
                                    onClick={this.handleShowSignup}><i className="flaticon-signup"/> Đăng ký
                            </button>
                        </li>
                        {this.props.url !== 'signup'
                        && (
                        <span className='d-flex'>
                            <li className="nav-item">
                                <button className="btn sign-in-btn" onClick={this.handleClick}>Đăng nhập</button>
                            </li>
                        </span>
                        )
                        }
                    </ul>
                }
            </div>
        );
    }
}

export default SidebarMobile
